import { Divider } from '@gluestack-ui/themed'
import isEmpty from 'lodash/isEmpty'
import React, { FunctionComponent } from 'react'
import { MansoryItemResult } from '../../../api/Favorites/types'
import { i18n } from '../../../lib/i18n'
import { openLink } from '../../../services/browserInApp'
import { getBubble } from '../../../services/bubble'
import { mailto } from '../../../services/mailto/mailto.services'
import { phoneCall } from '../../../services/phoneCall'
import { Card } from '../../Card'
import { MasonryList } from '../../MasonryList'

interface ReferentielMediaProps {
  phone?: string | null
  email?: string | null
  website?: string | null
  colums?: number
}

interface ReferentielMediaItem extends MansoryItemResult {
  component: React.ReactNode
}

export const ReferentielMedia: FunctionComponent<ReferentielMediaProps> = ({ phone, email, website, colums }) => {
  const items: ReferentielMediaItem[] = []

  const addItem = (component: React.ReactNode) => {
    items.push({
      id: items.length + 1,
      sizeX: 1,
      component,
    })
  }

  if (phone) {
    addItem(
      getBubble({
        link: {
          icon: 'call',
          iconTheme: 'MaterialIcons',
          label: i18n.t('call'),
        },
        onPress: async () => {
          await phoneCall(phone)
        },
      }),
    )
  }

  if (email) {
    addItem(
      getBubble({
        link: {
          icon: 'send-o',
          iconTheme: 'FontAwesome',
          label: 'Email',
        },
        onPress: async () => {
          await mailto(email)
        },
      }),
    )
  }

  if (website) {
    addItem(
      getBubble({
        link: {
          labelIn: 'www',
          label: i18n.t('website'),
        },
        onPress: () => openLink(website),
      }),
    )
  }

  if (isEmpty(items)) {
    return null
  }

  return (
    <>
      <Card spacing column noShadow>
        <MasonryList<ReferentielMediaItem>
          data={items}
          columns={colums || items.length || 4}
          columnHeight={80}
          columnJustify="flex-start"
          renderItem={(item: ReferentielMediaItem) => item.component}
        />
      </Card>
      <Divider />
    </>
  )
}
